
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Services from '@/components/Services';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import { updateMetaTags, getCanonicalUrl } from '@/utils/seoUtils';

const ServicesPage = () => {
  const { currentLanguage } = useLanguage();
  const { lang } = useParams<{ lang: string }>();
  const t = translations[currentLanguage];
  
  useEffect(() => {
    // Update SEO meta tags
    updateMetaTags({
      title: `${t.services} | Future Level`,
      description: t.pageDescription || 'Entdecken Sie unsere KI-gestützten Videomarketing Dienstleistungen: Produktvideos, Social Media Ads und mehr.',
      keywords: "Videomarketing Dienstleistungen, KI Videoproduktion, Produktvideos, Social Media Ads, AI Reels, Videoangebot",
      canonicalUrl: getCanonicalUrl(currentLanguage === 'de' ? 'leistungen' : 
                                   currentLanguage === 'en' ? 'services' : 
                                   currentLanguage === 'fr' ? 'services' : 'servizi', 
                                   currentLanguage),
      language: currentLanguage,
      ogType: "website"
    });
  }, [currentLanguage, t]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <div className="py-16 bg-gradient-to-b from-[#0B0B0B] to-[#101010]">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 font-future text-white micro-glitch">{t.ourServices}</h1>
              <p className="text-lg text-gray-300 max-w-3xl mx-auto">
                {t.servicesSubtitle}
              </p>
              <div className="w-3 h-3 rounded-full bg-purple-500 mx-auto mt-6 animate-pulse"></div>
            </div>
          </div>
        </div>
        
        <Services />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
